import {
  dashboard,
  userList,
  userMergeSuggestions,
  benefits,
  gym,
  gymTeacherDashboard,
  schools,
  findPhysicalSpaces,
  tickets,
  workouts,
  finances,
  calendar,
  associationTitles,
  healthInsuranceComparisonReport,
  lifeInsuranceComparisonReport,
  biometryEnroll,
  physicalSpaceReservations,
  physicalAccess,
  customReport,
  contracts,
  campaigns,
  spaceRenting,
  events,
  accountsPayablePage,
  accountsReceivablePage,
  contractsCrm,
  tasksBoard,
  notificationAnalytics,
  analyticsDashboard,
  aiUsageDashboard,
  nutritionDiary,
} from 'app/views/routes'
import { surveyBuilderNavigation } from 'app/navigation/surveyBuilderNavigation'
import { USER_TYPE } from './ducks/auth/types'
import { Theme } from './components/MatxTheme/themes'

export const navigations = [
  dashboard,
  {
    name: 'Administrativo',
    icon: 'admin_panel_settings',
    roles: [USER_TYPE.ADMINISTRATOR],
    allowedOnThemes: [
      Theme.HALL,
      Theme.AMSM,
      Theme.ACTION,
      Theme.AFA,
      Theme.EXOS,
      Theme.CIC,
      Theme.CLAB,
      Theme.BIOACADEMIA,
    ],
    children: [
      {
        name: 'Administração',
        path: `${process.env.REACT_APP_BACKEND_URL}/admin`,
        type: 'extLink',
        icon: 'admin_panel_settings',
        roles: [USER_TYPE.ADMINISTRATOR],
        allowedOnThemes: [Theme.AMSM, Theme.CLAB],
      },
      finances,
      accountsPayablePage,
      accountsReceivablePage,
      // physicalDeviceManagement,
      associationTitles,
      healthInsuranceComparisonReport,
      lifeInsuranceComparisonReport,
      userMergeSuggestions,
      notificationAnalytics,
      analyticsDashboard,
      aiUsageDashboard,
    ],
  },
  userList,
  tasksBoard,
  {
    ...workouts,
    name: 'Treinos',
    roles: [USER_TYPE.TOTEM],
  },
  gym,
  gymTeacherDashboard,
  nutritionDiary,
  surveyBuilderNavigation,
  {
    name: 'Contratos',
    icon: 'article',
    roles: [USER_TYPE.ADMINISTRATOR],
    allowedOnThemes: [
      Theme.HALL,
      Theme.AMSM,
      Theme.AFA,
      Theme.EXOS,
      Theme.ACTION,
    ],
    children: [contracts, contractsCrm],
  },
  campaigns,
  events,
  spaceRenting,
  schools,
  biometryEnroll,
  tickets,
  physicalAccess,
  calendar,
  benefits,
  customReport,
  findPhysicalSpaces,
  physicalSpaceReservations,
]
